<!--
  Restyled per Figma node 1688-41 ("Remaining time" pill above the Order
  Summary card): icon-first, "Remaining time:" label in medium weight,
  countdown value in bold, both in the design's blue, replacing the old
  plain-text "Your cart will expire in..." copy.

  `text-main` (`rgb(var(--default-color))`) replaces the Figma placeholder
  `#4397dd` so the pill follows the club's own brand colour instead of one
  fixed blue for every tenant (plan Decision #3).
-->
<h5
  class="flex justify-center md:justify-end items-center gap-1.5 text-main text-sm">
  <img src="/assets/img/clock-icon-blue.svg" alt="" class="w-[15px] h-[15px]" />
  <span class="font-medium">Remaining time:</span>
  <span class="font-bold">{{ getTimer }}</span>
</h5>
